import { AlertTriangle, Archive } from "lucide-react";
import Modal, { btnSecondary, btnPrimary } from "@/components/Modal";
import { label } from "@/lib/constants";

export default function DeleteBlockedModal({ message, references, onClose, onArchive, archiving }) {
  return (
    <Modal title="Cannot delete this record" onClose={onClose} testid="delete-blocked-modal">
      <div className="space-y-4" data-testid="delete-blocked-body">
        <div className="flex items-start gap-3 bg-[#FEF2F2] border border-[#FECACA] rounded-lg px-4 py-3">
          <AlertTriangle size={16} className="text-[#B91C1C] shrink-0 mt-0.5" />
          <p className="text-sm text-[#B91C1C] leading-relaxed">{message}</p>
        </div>
        <div>
          <h4 className="text-xs font-semibold tracking-wider uppercase text-[#8C7A6B] mb-2">Referenced by</h4>
          <div className="space-y-2">
            {Object.entries(references || {}).filter(([, n]) => n > 0).map(([key, count]) => (
              <div key={key} className="flex justify-between text-sm border border-[#F4EFEA] rounded-lg px-3 py-2" data-testid={`reference-${key}`}>
                <span className="text-[#5C4A3E]">{label(key)}</span>
                <span className="font-bold text-[#2A1810]">{count}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-end gap-3 pt-2 border-t border-[#F4EFEA]">
          <button onClick={onClose} className={btnSecondary} data-testid="blocked-cancel-button">Cancel</button>
          <button onClick={onArchive} disabled={archiving} className={btnPrimary} data-testid="archive-instead-button">
            <Archive size={14} /> {archiving ? "Archiving…" : "Archive instead"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
